import { Button, Modal, ModalBody, Radio } from "@ht/components";
import { FC, useState } from "react";
import ConfirmIcon from "@ht/shared/fonts/deos-pis/msg-confirm";

export const PresenceBox: FC<{
    visible: boolean, title?: string, message?: string,
    yesBtn?: string, noBtn?: string
    yesHandler: (reason: string, label: string) => void;
    noHandler: () => void;
}> = ({ visible, yesHandler, noHandler, title = "Go Offline", message = "Please select the reason of you going offline. When offline, you will not receive any incoming call/chat.", yesBtn = "Go Offline", noBtn = "No, Don't" }) => {
    const [reason, setReason] = useState<{ reason: string, label: string }>()
    const reasonlist: any[] = [
        {
            reason: "lunch",
            label: "Lunch"
        },
        {
            reason: "restroom",
            label: "Restroom"
        },
        {
            reason: "brief",
            label: "Brief"
        },
        {
            reason: "prayer",
            label: "Prayer"
        }
    ]
    return (
        <>
            <Modal show={visible} size="sm" >
                <ModalBody className="!p-5 flex items-center justify-center flex-col w-full">
                    <div className="mb-6 self-center" >
                        <ConfirmIcon className="text-primary" />
                    </div>
                    <div className="text-[16px] font-bold text-gray-700">{title}</div>
                    <div className="text-md mt-[6px] text-gray-400 text-center">{message}</div>
                    <div className="flex flex-wrap gap-[12px] pt-4 px-2">
                        {reasonlist.map((rsn) => {
                            return (<div key={rsn.reason} className="w-[145px] cursor-pointer"><Radio className="cursor-pointer" id={rsn.reason} name={rsn.reason} label={rsn.label} value={rsn.reason} onChange={() => setReason({ reason: rsn.reason, label: rsn.label })} checked={reason?.reason === rsn.reason}></Radio></div>
                            )
                        })}
                    </div>
                    <div className="flex w-full mt-6 gap-4">
                        <Button shape="rounded" onClick={noHandler}
                            className="cursor-pointer w-full h-10 border-gray-200 hover:border-gray-200 hover:bg-white bg-white rounded-lg !text-md text-gray-700 !font-bold"
                        >{noBtn}</Button>
                        <Button shape="rounded" disabled={reason === undefined} color="primary" onClick={() => reason !== undefined && yesHandler(reason?.reason ?? "", reason?.label ?? "")}
                            className="cursor-pointer w-full h-10 rounded-lg !text-md !font-bold  hover:border-primary hover:bg-primary disabled:bg-gray-200 disabled:border-gray-200 disabled:hover:bg-gray-100"
                        >{yesBtn}</Button>
                    </div>
                </ModalBody>
            </Modal>
        </>);
}